import { Model } from 'vuex-orm';
import moment from 'moment';

import User from '../user/model';
import Category from '../category/model';

export default class TimeLog extends Model {
  static entity = 'timeLogs';

  static fields() {
    return {
      id: this.attr(null),
      user_id: this.attr(null),
      category_id: this.attr(null),
      type: this.attr(''),
      status: this.attr(''),
      note: this.attr(''),
      started_at: this.attr(''),
      actual_started_at: this.attr(''),
      stopped_at: this.attr(''),
      actual_stopped_at: this.attr(''),
      custom: this.attr(false),
      deleted: this.attr(false),
      deleted_at: this.attr(),
      versions_count: this.attr(0),
      created_at: this.attr(''),
      updated_at: this.attr(''),
      logged_days: this.attr(''),
      user: this.belongsTo(User, 'user_id'),
      category: this.belongsTo(Category, 'category_id'),
    };
  }

  parse() {
    if (this.started_at) this.started_at = moment(this.started_at);
    if (this.stopped_at) this.stopped_at = moment(this.stopped_at);

    return this;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/timeLog/model.js